/* global setPermanentCookie */

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["teamControl", "individualControl", "team", "individual"]

  showTeams(event) {
    event.preventDefault()

    this.teamControlTarget.classList.add("active")
    this.individualControlTarget.classList.remove("active")
    this.teamTarget.style.display = ""
    this.individualTarget.style.display = "none"
    setPermanentCookie("standings_mode", "team")
  }

  showIndividual(event) {
    event.preventDefault()

    this.teamControlTarget.classList.remove("active")
    this.individualControlTarget.classList.add("active")
    this.teamTarget.style.display = "none"
    this.individualTarget.style.display = ""
    setPermanentCookie("standings_mode", "individual")
  }
}
